import { render, staticRenderFns } from "./FooterAccordionItem.vue?vue&type=template&id=410a2efe&scoped=true"
import script from "./FooterAccordionItem.vue?vue&type=script&lang=js"
export * from "./FooterAccordionItem.vue?vue&type=script&lang=js"
import style0 from "./FooterAccordionItem.vue?vue&type=style&index=0&id=410a2efe&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410a2efe",
  null
  
)

export default component.exports